import { createSlice } from '@reduxjs/toolkit';

const mediaSlice = createSlice({
  name: 'media',
  initialState: {
    value: '',
  },
  reducers: {
    changeMedia: (state, {payload}) => {
      state.value = payload;
    },
    resetReduxToolkitState: state => {
      state.value = '';
    },
  },
});

export const { 
    changeMedia,
    resetReduxToolkitState
 } = mediaSlice.actions;

export default mediaSlice.reducer;
